import React from 'react'
import { TableCell } from '@material-ui/core'
import { useReportStyles } from './report-tab-styles'

export type TableHeaderUnitCellProps = {
  firstRow: string
  secondRow?: string
  omitPadding?: boolean
}

export function TableHeaderUnitCell({
  firstRow,
  secondRow,
  omitPadding = false,
}: TableHeaderUnitCellProps): React.ReactElement {
  const classes = useReportStyles()
  const cellClass = omitPadding
    ? classes.tableHeaderUnitCellWithoutPadding
    : classes.tableHeaderUnitCell

  return (
    <TableCell className={cellClass}>
      {firstRow}
      {secondRow ? <br /> : null}
      {secondRow}
    </TableCell>
  )
}
